import TipoPresupuestoService from 'src/modules/tipoPresupuesto/tipoPresupuestoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'TIPOPRESUPUESTO_FORM';

const tipoPresupuestoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoPresupuestoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TipoPresupuestoService.find(id);
      }

      dispatch({
        type: tipoPresupuestoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoPresupuestoFormActions.INIT_ERROR,
      });

      getHistory().push('/tipo-presupuesto');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: tipoPresupuestoFormActions.CREATE_STARTED,
      });

      await TipoPresupuestoService.create(values);

      dispatch({
        type: tipoPresupuestoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoPresupuesto.create.success'),
      );

      getHistory().push('/tipo-presupuesto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoPresupuestoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tipoPresupuestoFormActions.UPDATE_STARTED,
      });

      await TipoPresupuestoService.update(id, values);

      dispatch({
        type: tipoPresupuestoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoPresupuesto.update.success'),
      );

      getHistory().push('/tipo-presupuesto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoPresupuestoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default tipoPresupuestoFormActions;
